<!--

  <fa-kt-delete-abteilung [style.width]="'100%'" [value]="$deleteAbteilung | async" (finished)="finishedDeleteAbteilung($event)"></fa-kt-delete-abteilung>
    
  <fa-kt-post-abteilung [style.width]="'100%'" [value]="$postAbteilung | async" (finished)="finishedPostAbteilung($event)"></fa-kt-post-abteilung>
    


-->
<!--- << custom    -->
<nz-list *ngIf="abteilungen" nzSize="large" [nzLoading]="$loading | async">
  <nz-list-item *ngFor="let abteilung of abteilungen" (click)="openAbteilung(abteilung)">
    <nz-list-item-meta [nzDescription]="ListDescription">
      <ng-template #ListDescription> </ng-template>
      <nz-list-item-meta-title>
        <a>
          {{ abteilung.name }}
          <nz-divider nzType="vertical"></nz-divider>
          <span nz-typography nzType="secondary">
            {{ abteilung.aktiv ? 'aktiv' : 'inaktiv' }}
          </span>
        </a>
      </nz-list-item-meta-title>
    </nz-list-item-meta>
    <ul nz-list-item-actions>
      <nz-list-item-action>
        <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
      </nz-list-item-action>
    </ul>
  </nz-list-item>
  <nz-list-item>
    <button nz-button (click)="openAbteilung({})" nzType="dashed" [disabled]="disabled">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
      Abteilung hinzufügen
    </button>
  </nz-list-item>
</nz-list>

<nz-modal [nzTitle]="ModalTitle" [nzContent]="ModalContent" [nzFooter]="ModalFooter" (nzOnCancel)="openAbteilung(null)" [nzVisible]="!!($postAbteilung | async)">
  <ng-template #ModalTitle>
    <nz-page-header [nzTitle]="ModalHeaderTitle">
      <ng-template #ModalHeaderTitle> Abteilung </ng-template>
      <nz-breadcrumb nz-page-header-breadcrumb> </nz-breadcrumb>
      <nz-page-header-extra>
        <fa-kt-delete-abteilung [style.width]="'100%'" [value]="$deleteAbteilung | async" (finished)="finishedDeleteAbteilung()"></fa-kt-delete-abteilung>
      </nz-page-header-extra>
    </nz-page-header>
  </ng-template>
  <ng-template #ModalContent>
    <nz-row>
      <fa-kt-post-abteilung
        [style.width]="'100%'"
        [value]="$postAbteilung | async"
        (finished)="finishedPostAbteilung()"
        [businessHomePage]="businessHomePage"
        [companyName]="companyName"
      ></fa-kt-post-abteilung>
    </nz-row>
  </ng-template>
  <ng-template #ModalFooter>
    <pbc-meta [value]="($postAbteilung | async)?.abteilung"></pbc-meta>
  </ng-template>
</nz-modal>
<!---    custom >> -->
